











































import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"
import BusinessGetStartedAccountDetails from "./BusinessGetStartedAccountDetails.vue"
import AuthResendBtn from "@/components/Auth/AuthResendBtn.vue"
import AuthErrorAlert from "@/components/Auth/AuthErrorAlert.vue"

@Component({
  components: {
    BusinessGetStartedAccountDetails,
    AuthResendBtn,
    AuthErrorAlert
  },
  computed: {
    ...mapState("Auth", {
      businessSignUpDetails: "businessSignUpDetails",
    }),
  },
})
export default class BusinessGetStarted extends Vue {
  businessSignUpDetails!: {
    email: string;
  }

  step = 1

  isActivated = false

  isResendLoading = false

  errors = []

  handleResendEmail() {
    return this.$store
      .dispatch("Auth/sendActivationEmail", {
        email: this.businessSignUpDetails.email,
      })
      .then((response) => {
        const needActivation = response.data.data.need_activation
        if (! needActivation) {
          this.isActivated = true
        }
      })
      .catch(({ response }) => {
        let errorMessage = response.data.error
        if (
          typeof errorMessage === "string" ||
          errorMessage instanceof String
        ) {
          errorMessage = [[errorMessage]]
        }
        this.errors = errorMessage
      })
  }
}
